import styled from 'styled-components'
import { layout, LayoutProps, space, SpaceProps } from 'styled-system'

export const SectionWrapper = styled.div<SpaceProps & LayoutProps>`
	${space}
	${layout}
`
